module.exports = __webpack_public_path__ + "static/media/icon-close-blue.749034df.svg";